'use client';

import { type SliceCreator, type EditorStore, type EditorDataSlice } from './type';

export const createEditorDataSlice: SliceCreator<EditorDataSlice, EditorStore> = () => ({
    flatMap: {},
    styleMap: {},
    contentMap: {},
    siteStyle: {},
    nodeVersionMap: {},
    rootSections: { header: [], footer: [], body: [] },
    pageLayoutMeta: {
        header: null,
        footer: null,
        body: null,
    },
    editingSectionName: null,
    editingLayoutId: null,
    editingElementType: null,
    editingElementId: null,
    editingNodeChain: [],
    hoverElementId: null,
    nextInsertSectionId: null,
    isDirty: false,
});
